import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import {
  IOptimizationService,
  OptimizationState,
} from '@infinitform/platform-core';
import { CLOUD_PLATFORM_CONFIG } from '../config';

@Injectable()
export class OptimizationCloudService implements IOptimizationService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(CLOUD_PLATFORM_CONFIG);

  triggerOptimization(
    projectId: string,
    config?: Record<string, unknown>
  ): Observable<{ jobId: string }> {
    return this.http
      .post<Record<string, unknown>>(
        `${this.config.apiBaseUrl}/project/${projectId}/optimize`,
        config ?? {}
      )
      .pipe(
        map((response) => ({
          jobId: (response['jobId'] as string) ?? projectId,
        }))
      );
  }

  getStatus(projectId: string): Observable<OptimizationState> {
    return this.http
      .get<Record<string, unknown>>(
        `${this.config.apiBaseUrl}/project/${projectId}`
      )
      .pipe(
        map((project) => {
          const status = project['status'] as string;
          const statusMap: Record<string, OptimizationState['status']> = {
            new: 'idle',
            queued: 'queued',
            processing: 'processing',
            completed: 'completed',
            error: 'error',
          };
          return {
            status: statusMap[status] ?? 'idle',
            jobId: projectId,
          };
        })
      );
  }

  cancelOptimization(projectId: string): Observable<void> {
    return this.http.post<void>(
      `${this.config.apiBaseUrl}/project/${projectId}/optimize/kill`,
      {}
    );
  }
}
